/** Query keys for shipping-lines financial statement flows (shareable / refresh-safe URLs). */

export const FS_QUERY = {
  SHIPPING_LINE_NAME: 'name',
  SHIPPING_LINE_ID: 'shipping_line_id',
  SOA_ID: 'soa_id',
  INVOICE_ID: 'invoice_id',
  BILLING_STATEMENT_ID: 'billing_id',
  EXPECTED_DATE_FROM: 'from',
  EXPECTED_DATE_TO: 'to',
} as const

export type FinancialStatementsQueryInput = {
  shippingLineName?: string
  soaId?: number
  expectedDateFrom?: string
  expectedDateTo?: string
}

export function buildFinancialStatementsQuery(input: FinancialStatementsQueryInput): string {
  const p = new URLSearchParams()
  if (input.shippingLineName) {
    p.set(FS_QUERY.SHIPPING_LINE_NAME, input.shippingLineName)
  }
  if (input.soaId != null && Number.isFinite(input.soaId)) {
    p.set(FS_QUERY.SOA_ID, String(input.soaId))
  }
  if (input.expectedDateFrom) {
    p.set(FS_QUERY.EXPECTED_DATE_FROM, input.expectedDateFrom)
  }
  if (input.expectedDateTo) {
    p.set(FS_QUERY.EXPECTED_DATE_TO, input.expectedDateTo)
  }
  const s = p.toString()
  return s ? `?${s}` : ''
}

export function shippingLineNameFromSearchParams(sp: URLSearchParams): string {
  return sp.get(FS_QUERY.SHIPPING_LINE_NAME) ?? ''
}

export function shippingLineIdFromSearchParams(sp: URLSearchParams): string | undefined {
  const raw = sp.get(FS_QUERY.SHIPPING_LINE_ID)
  if (raw == null || raw === '') return undefined
  return raw
}

export function soaIdFromSearchParams(sp: URLSearchParams): number | undefined {
  const raw = sp.get(FS_QUERY.SOA_ID)
  if (raw == null || raw === '') return undefined
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? n : undefined
}

export function invoiceIdFromSearchParams(sp: URLSearchParams): number | undefined {
  const raw = sp.get(FS_QUERY.INVOICE_ID)
  if (raw == null || raw === '') return undefined
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? n : undefined
}

export function billingStatementIdFromSearchParams(sp: URLSearchParams): number | undefined {
  const raw = sp.get(FS_QUERY.BILLING_STATEMENT_ID)
  if (raw == null || raw === '') return undefined
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? n : undefined
}

export function expectedDateFromSearchParams(sp: URLSearchParams): string | undefined {
  const v = sp.get(FS_QUERY.EXPECTED_DATE_FROM)
  return v && v.length > 0 ? v : undefined
}

export function expectedDateToSearchParams(sp: URLSearchParams): string | undefined {
  const v = sp.get(FS_QUERY.EXPECTED_DATE_TO)
  return v && v.length > 0 ? v : undefined
}
